import React, { useEffect, useState } from 'react';
import { DataTableColumn } from '@common/components/datatable/types';
import { useTranslation } from 'react-i18next';
import { Button } from '@common/components/button';

type FunctionGroup = {
  externalId: string;
  name: string;
  linked_with: any[];
};

type Props = {
  onImportFunction: (functionGroup: FunctionGroup) => void;
};

export default ({ onImportFunction }: Props) => {
  const { t } = useTranslation();
  const [columns, setColumns] = useState<DataTableColumn[]>([]);

  useEffect(() => {
    const baseColumns: DataTableColumn[] = [
      {
        key: 'name',
        label: t('organisation:sync_result_name'),
        options: {
          render: (functionGroup: FunctionGroup) => (
            <div className="tw-text-sm tw-text-gray-900 tw-font-medium">
              {functionGroup.name}
            </div>
          ),
        },
      },
      {
        key: 'action',
        label: '',
        options: {
          align: 'right',
          render: (functionGroup: FunctionGroup) => (
            <div className="tw-flex tw-justify-end">
              <Button
                type="default"
                size="small"
                onClick={() => onImportFunction(functionGroup)}
              >
                {t('organisation:import')}
              </Button>
            </div>
          ),
        },
      },
    ];
    setColumns(baseColumns);
  }, [t]);

  return columns;
};
